// src/services/applicationService.js

import api from './api';

// Function to fetch all applications
export const getApplications = async () => {
  try {
    const response = await api.get('/applications');
    return response.data;
  } catch (error) {
    console.error('Error fetching applications:', error);
    throw error;
  }
};

// Function to delete an application by ID
export const deleteApplication = async (id) => {
  try {
    await api.delete(`/applications/${id}`);
  } catch (error) {
    console.error(`Error deleting application with ID ${id}:`, error);
    throw error;
  }
};
